import { UntypedFormControl } from '@angular/forms';
import { BehaviorSubject, combineLatest, debounceTime, distinctUntilChanged, filter, map, ReplaySubject } from 'rxjs';
import { AggregationsType } from 'src/app/models/api/aggregations.model';
import { FilterTypesEnum } from 'src/app/models/filters/filterTypes.enum';
import { ISelectOption } from 'src/app/models/selectOptions';
import { AggregationsHttpServiceService } from 'src/app/services/httpServices/aggregationsHttpService/aggregations-http-service.service';
import { IVerticalDynamicFilter } from '../models/filters/interfaces/verticalDynamicFilter.interface';

export const createDepartmentVerticalFilter = () =>
  ({
    valuesCtrl: new UntypedFormControl(),
    isLoading$: new BehaviorSubject(false),
    filterEnum: FilterTypesEnum.Department,
    searchNewValue: new ReplaySubject<string[] | undefined>(1),
  }) as IVerticalDynamicFilter;

const departmentNameToSelectOption = (department: string) =>
  ({
    id: encodeURIComponent(department),
    value: encodeURIComponent(department),
    displayName: department,
    filterType: FilterTypesEnum.Department,
    categoryName: FilterTypesEnum.Department,
    withoutBeautifyDisplayName: true,
  }) as ISelectOption;

export const initDepartmentFilter = (
  aggregationsHttpService: AggregationsHttpServiceService,
  dynamicFilter: IVerticalDynamicFilter
) => {
  const availableDepartmentsListener = aggregationsHttpService.getAggregations(AggregationsType.common).pipe(
    map((data) => Object.keys(data?.aggregationsData?.resourcesCreatedPerDepartment?.data || [])), // get list of department names only
    map((departmentList) => departmentList.filter((department) => department.length >= 1)) // filter out the default department
  );

  const queryListener = dynamicFilter.valuesCtrl.valueChanges.pipe(
    filter((res) => typeof res === 'string'),
    distinctUntilChanged(),
    debounceTime(100)
  );

  combineLatest([availableDepartmentsListener, queryListener]).subscribe(
    ([availableDepartments, query]) =>
      (dynamicFilter.values = availableDepartments
        .filter((department) => department.toLowerCase().includes(query.toLowerCase()))
        .map(departmentNameToSelectOption))
  );
};

export const encodedDepartmentsToSelection = (encodedDepartmentNames: string[]) =>
  encodedDepartmentNames.map(
    (encodedDepartment) =>
      ({
        id: encodedDepartment,
        value: encodedDepartment,
        displayName: decodeURIComponent(encodedDepartment),
        filterType: FilterTypesEnum.Department,
        categoryName: FilterTypesEnum.Department,
        withoutBeautifyDisplayName: true,
      }) as ISelectOption
  );
